// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"696":"db324f31","726":"a194d792","901":"c5a2cc62"}[chunkId] + ".chunk.js";
};